<template>
  <div class="admin-page" @click="generalClick">
    <div class="admin-page-inner">
      <div class="admin-page-header">
        <div class="admin-page-heading">
          <button
            type="button"
            class="admin-button--secondary admin-button--sm"
            @click="$router.push({ name: 'AdminData' })"
          >
            <i class="fa fa-arrow-left mr-2" aria-hidden="true"></i>Zurück
          </button>
          <div>
            <span class="admin-kicker">Datenverwaltung</span>
            <h1 class="admin-page-title">Vorlagen</h1>
          </div>
        </div>
        <div class="admin-action-bar">
          <button type="button" class="admin-button--primary" @click="showUploadModal = true">
            Neue Vorlage hochladen
          </button>
        </div>
      </div>

    <div class="w-full mt-2">
      <section class="admin-panel overflow-x-auto">
        <table class="w-full">
          <thead class="bg-gray-500 text-white sticky top-0 z-50">
            <tr>
              <th class="py-3 px-4 font-semibold text-sm uppercase text-left">Name</th>
              <th class="py-3 px-4 font-semibold text-sm uppercase text-left">Zweck</th>
              <th class="py-3 px-4 font-semibold text-sm uppercase text-left">Platzhalter</th>
              <th class="py-3 px-4 font-semibold text-sm uppercase text-left">Aktionen</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="template in templates" :key="template.id" class="border-b border-gray-200 hover:bg-gray-50">
              <td class="py-3 px-4">{{ template.name }}</td>
              <td class="py-3 px-4">{{ template.purpose }}</td>
              <td class="py-3 px-4">{{ template.placeholders.join(', ') }}</td>
              <td class="py-3 px-4">
                <button type="button" class="admin-button--primary admin-button--sm mr-2" @click="openGenerateModal(template)">
                  Generieren
                </button>
                <button type="button" class="admin-button--secondary admin-button--sm mr-2" @click="getTemplateFile(template)">Download</button>
                <button type="button" class="admin-button--danger admin-button--sm mr-2" @click="deleteTemplate(template)">Löschen</button>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-if="loading" class="text-center py-8">Lade Vorlagen...</div>
    <div v-else-if="templates.length === 0" class="text-center py-8 text-gray-500">
      Keine Vorlagen vorhanden.
    </div>
      </section>
    </div>
    <TemplateUploadModal v-if="showUploadModal" @close="showUploadModal = false" @uploaded="onUploaded" />
    <GenerateFromTemplateModal v-if="showGenerateModal && selectedTemplate" :template="selectedTemplate" @close="showGenerateModal = false" @generated="onGenerated" />
    </div>
  </div>
</template>

<script>
import CASP from '@/CASP.js';
import TemplateUploadModal from './TemplateUploadModal.vue';
import GenerateFromTemplateModal from './GenerateFromTemplateModal.vue';

export default {
  name: 'TemplateDashboard',
  components: { TemplateUploadModal, GenerateFromTemplateModal },
  data() {
    return {
      templates: [],
      loading: true,
      showUploadModal: false,
      showGenerateModal: false,
      selectedTemplate: null,
    };
  },
  methods: {
    fetchTemplates() {
      this.loading = true;
      CASP.listTemplates((status, result) => {
        this.templates = result.templates || [];
        this.loading = false;
        document.getElementById("mainspinner").style.display = "none";

      });
    },
    onUploaded() {
      this.showUploadModal = false;
      this.fetchTemplates();
    },
    openGenerateModal(template) {
      this.selectedTemplate = template;
      this.showGenerateModal = true;
    },
    deleteTemplate(template){
      CASP.deleteTemplate(template.id, (status, result) => {
        if (status == 200) {
          this.fetchTemplates();
        }
      });
    },
    getTemplateFile(template){
      CASP.getOriginalTemplate(template.id, (status, result) => {
        if (status == 200 && result) {
          // Download file
          const a = document.createElement('a');
          a.href = result.file;
          a.download = template.name + ".docx";
          document.body.appendChild(a);
          a.click();
          setTimeout(() => {
            document.body.removeChild(a);
          }, 100);
        }
      });
    },
    onGenerated() {
      this.showGenerateModal = false;
    }
  },
  created() {
    this.fetchTemplates();
  }
};
</script>

<style scoped>
</style>
